import { Link } from "react-router";
import { AREAS, AREA_LABELS } from "@shared/permissions";
import type { HubSite, Me } from "@/lib/hub";

// The hub's home: one card per website this person may open, with what they may do there.

function access(site: HubSite) {
  if (site.owner) return "Owner: everything";
  const parts = AREAS.filter((a) => site.grant[a]).map((a) => `${AREA_LABELS[a].name}${site.grant[a] === "view" ? " (view)" : ""}`);
  return parts.join(" · ");
}

export function Home({ sites, me }: { sites: HubSite[]; me: Me }) {
  return (
    <div>
      <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Hello{me.name ? `, ${me.name.split(" ")[0]}` : ""}</h1>
      <p className="mt-2 text-midnight/70">Choose a website to manage.</p>
      {sites.length ? (
        <ul className="mt-8 grid gap-4 sm:grid-cols-2">
          {sites.map((site) => (
            <li key={site.id} className="flex flex-col gap-3 rounded-2xl border border-midnight/10 bg-sand p-5 sm:p-6">
              <div className="flex items-baseline justify-between gap-3">
                <h2 className="text-xl font-bold">{site.name}</h2>
                <a href={site.url} target="_blank" rel="noreferrer" className="shrink-0 py-2 text-sm text-teal underline underline-offset-4">
                  Visit ↗
                </a>
              </div>
              <p className="text-sm break-all text-midnight/70">{site.url.replace(/^https:\/\//, "")}</p>
              <p className="text-sm">{access(site)}</p>
              <Link to={`/sites/${site.id}`} className="mt-auto inline-flex min-h-11 w-fit items-center rounded-lg bg-midnight px-5 font-mono text-[0.7rem] tracking-[0.15em] text-offwhite uppercase hover:bg-teal">
                Open dashboard →
              </Link>
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-8 rounded-2xl border border-dashed border-midnight/20 p-8 text-center text-midnight/70">
          You don&apos;t have access to any website yet. Ask an owner to give you access.
        </p>
      )}
    </div>
  );
}
